import React, { useEffect, useRef, useState } from "react";
import certificateImg1 from "../CertificatedCard_Section/images/certifictaeImg1.png";
import certificateImg2 from "../CertificatedCard_Section/images/certifictaeImg2.png";
import certificateImg3 from "../CertificatedCard_Section/images/certifictaeImg3.png";
import certificateImg4 from "../CertificatedCard_Section/images/certifictaeImg4.png";

const CertificateCard_Section = () => {
    const certificates = [
        { img: certificateImg1, title: "ISO 9001:2015", subtitle: "Quality Management" },
        { img: certificateImg2, title: "Meta Business Partner", subtitle: "Verified Messaging" },
        { img: certificateImg3, title: "CMMI Level 3", subtitle: "Process Maturity" },
        { img: certificateImg4, title: "ISO 27001:2013", subtitle: "Information Security" },
    ];

    // NEW: animate on scroll
    const sectionRef = useRef(null);
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const ob = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                    ob.disconnect(); // run only once
                }
            },
            { threshold: 0.2 }
        );
        if (sectionRef.current) ob.observe(sectionRef.current);
        return () => ob.disconnect();
    }, []);

    return (
        <section
            ref={sectionRef}                                      // NEW
            className={`py-5 position-relative ${visible ? "is-visible" : ""}`} // NEW
            style={{
                overflow: "hidden",
                background: "linear-gradient(90deg, #ECF4FF 0%, #F6F9FF 100%)",
                marginTop: "80px",
            }}
        >
            <div
                className="px-5 x-xxl-5 px-6 mx-auto position-relative"
                style={{ maxWidth: "74%", textAlign: "center" }}
            >
                {/* Heading */}
                <h2
                    className="fade-top"
                    style={{
                        fontSize: "2.5rem",
                        fontFamily: "Inter",
                        fontWeight: 700,
                        color: "#242121ff",
                        lineHeight: 1.2,
                    }}
                >
                    Why brands trust{" "}
                    <span
                        style={{
                            ontFamily: 'Poppins',
                            fontWeight: 700,
                            background: 'linear-gradient(90deg, #317cbeff 0%, #59C0FB 100%)',
                            WebkitBackgroundClip: 'text',
                            backgroundClip: 'text',
                            color: 'transparent',
                        }}
                    >
                        Vertex
                    </span>{" "}
                    <span
                        style={{
                            background: "linear-gradient(90deg, #1F88E5 0%, #6EC9FF 100%)",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            display: "inline-block",
                            fontWeight: 700,
                        }}
                    >
                        Suite
                    </span>
                </h2>

                {/* Sub-heading */}
                <p
                    className="fade-top"
                    style={{
                        marginTop: -2,
                        color: "#413e3eff",
                        fontSize: "1.1rem",
                        fontFamily: "Poppins",
                        fontWeight: 300,
                        maxWidth: "700px",
                        lineHeight: 1.2,
                        margin: "0 auto 40px auto",
                    }}
                >
                    We are certified by the world's most trusted standards- ISO,
                    CMMI and Meta. Our platform is engineered for reliability, security
                    and scalability.
                </p>

                {/* Card container */}
                <div
                    className="cards-grid fade-bottom"
                    style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(4, 1fr)",
                        gap: "20px",
                    }}
                >
                    {certificates.map((cert, index) => (
                        <div
                            key={index}
                            style={{
                                background: "#fff",
                                borderRadius: "12px",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                                padding: "30px 16px",
                                minHeight: "180px",
                                marginBottom: "30px",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <img
                                src={cert.img}
                                alt={`certificate-${index + 1}`}
                                style={{
                                    maxWidth: "100%",
                                    maxHeight: "80px",
                                    objectFit: "contain",
                                    marginBottom: "16px",
                                }}
                            />
                            <h3
                                style={{
                                    fontSize: "18px",
                                    color: "#242121ff",
                                    fontWeight: 600,
                                    margin: "0 0 4px 0",
                                    fontFamily: "Lato",
                                }}
                            >
                                {cert.title}
                            </h3>
                            <p
                                style={{
                                    fontSize: "1.1rem",
                                    fontFamily: "Lato",
                                    fontWeight: 400,
                                    color: "#413e3eff",
                                    margin: 0,
                                    lineHeight: 1.3,
                                    wordSpacing: "2px",
                                }}
                            >
                                {cert.subtitle}
                            </p>
                        </div>
                    ))}
                </div>
            </div>

            {/* NEW: Entrance animations */}
            <style>{`
        .fade-top{
          opacity: 0;
          transform: translateY(-16px);
          transition: opacity .7s ease-out, transform .7s ease-out;
        }
        .fade-bottom, .cards-grid.fade-bottom{
          opacity: 0;
          transform: translateY(16px);
          transition: opacity .8s ease-out, transform .8s ease-out;
        }
        .is-visible .fade-top{
          opacity: 1;
          transform: translateY(0);
        }
        .is-visible .fade-bottom{
          opacity: 1;
          transform: translateY(0);
        }
      `}</style>
        </section>
    );
};

export default CertificateCard_Section;
